import React, { Component } from 'react'
import './NavigatorButton.css'

export default class NavigatorLiveTrading extends Component {
  _handleClick() {
    this.props.history.push('/livetrading')
  }

  render () {
    return (
      <div style={{paddingLeft: 8}}>
        <span className='navigator-button' onMouseDown={() => this._handleClick()}>
          Live-Trading
        </span>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/NavigationBar/NavigatorLiveTrading.js